import React from 'react';
import { Listing } from '../rql';
import { ITEM_WITH_SLUG_ROUTE } from '../url_helpers';
import { LISTING_STATES } from '../constants';

interface Props {
  listing: Listing;
}

function listingItemPageMetaDataUrl(listing: Listing): string {
  const { id, slug } = listing;

  return `https://reverb.com${ITEM_WITH_SLUG_ROUTE.expand({ id, slug })}`;
}

function onSale(listing): boolean {
  if (listing.sale) {
    return listing.sale.state === 'LIVE' && !!listing.sale.endsAt;
  }
}

function isInStock(listing: Listing): boolean {
  const { inventory, state } = listing;

  if (inventory > 0) { return true; }
  if (state === LISTING_STATES.LIVE) { return true; }
  return false;
}

export function renderAvailability(listing: Listing) {
  const { preorderInfo } = listing;

  if (preorderInfo?.onPreorder) {
    return <meta itemProp="availability" content="https://schema.org/PreOrder" />;
  }

  if (isInStock(listing)) {
    return <meta itemProp="availability" content="https://schema.org/InStock" />;
  }

  return null;
}

export function ListingOfferMetadata(props: Props) {
  const { listing } = props;

  return (
    <div itemProp="offers" itemScope itemType="http://schema.org/Offer">
      <meta itemProp="priceCurrency" content={listing.pricing.buyerPrice.currency} />
      <meta itemProp="price" content={`${listing.pricing.buyerPrice.amountCents / 100}`} />
      {renderAvailability(listing)}
      <meta itemProp="url" content={listingItemPageMetaDataUrl(listing)} />
      <meta itemProp="gtin14" content={listing.upc} />
      {onSale(listing) && <meta itemProp="priceValidUntil" content={`P${listing.sale.endsAt.seconds}s`} />}
    </div>
  );
}
